import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Formsy from "formsy-react";
import { Input } from "formsy-react-components";

import { Row, Col } from "react-bootstrap";

import * as modalActions from "../../actions/modalActions";

import ChangePassForm from "./ChangePassForm";

import Modal from "../common/Modal";
import CustomToggle from "./Toggle";

class ProfileForm extends Component {
  constructor(props) {
    super(props);
    this.state = { checked: false, canSubmit: false };
  }

  componentDidMount = () => {
    this.setState({ checked: this.props.user.is_night_mode });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  handleToggle = (e) => {
    this.setState({ checked: e.target.checked });
  };

  cancel = () => {
    this.props.onCancel();
  };

  submit = (model) => {
    this.props.onSave(model);
  };

  updatePassword = (model) => {
    this.props.handleChangePassword(model);
    this.props.actions.hideModal();
  };

  render() {
    const { user, saving } = this.props;

    const changePasswordForm = (
      <ChangePassForm
        user={user}
        onSave={this.updatePassword}
        onCancel={this.props.actions.hideModal}
        saving={saving}
      />
    );

    return (
      <React.Fragment>
        <Formsy
          className="vertical form"
          onValidSubmit={this.submit}
          autoComplete="off"
          onValid={this.enableButton}
          onInvalid={this.disableButton}
        >
          <Row>
            <Col md={5} xs={12}>
              <Input
                formNoValidate
                required
                name="first_name"
                label="First Name"
                disabled={!this.props.editing}
                placeholder="First Name"
                value={user.first_name}
              />
            </Col>
            <Col md={2} xs={12}>
              <Input
                formNoValidate
                name="middle_initial"
                label="Middle Initial"
                disabled={!this.props.editing}
                placeholder="Middle Initial"
                value={user.middle_initial}
              />
            </Col>
            <Col md={5} xs={12}>
              <Input
                formNoValidate
                required
                name="last_name"
                label="Last Name"
                disabled={!this.props.editing}
                placeholder="Last Name"
                value={user.last_name}
              />
            </Col>
            <Col md={12} xs={12}>
              <Input
                formNoValidate
                required
                name="email"
                label="Email"
                placeholder="Email"
                value={user.email}
                disabled={!this.props.editing}
                validations="isEmail"
                validationError="This is not a valid email"
              />
            </Col>
            <Col md={12} xs={12}>
              <span
                className="pull-right form-action"
                role="presentation"
                onKeyDown={() => {}}
                onClick={this.props.onChangePassword}
              >
                Change Password
              </span>
            </Col>
            <Col md={2} xs={12}>
              <CustomToggle
                formNoValidate
                name="is_night_mode"
                label="Night Mode"
                disabled={!this.props.editing}
                onChange={this.handleToggle}
                value={this.state.checked.toString()}
                checked={this.state.checked}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} xs={12} className="footer">
              <button
                className="btn  btn-cancel"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
              <input
                className="btn btn-success"
                type="submit"
                disabled={!this.state.canSubmit || this.props.saving}
                value={this.props.saving ? "Saving... " : "Save"}
              />
            </Col>
          </Row>
        </Formsy>
        <Modal
          id="userDetailsModal"
          title="Change Password"
          body={changePasswordForm}
          close={this.props.actions.hideModal}
        />
      </React.Fragment>
    );
  }
}

ProfileForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  editing: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  actions: PropTypes.object,
  handleChangePassword: PropTypes.func,
  onChangePassword: PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...modalActions }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(ProfileForm);
